import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface RefillAlertsList {
  isLoading: boolean;
  error: boolean;
  message?: string | null;
  RefillAlertsListData?: any;
  Items?: any;
  Pagination?: any;
}

const initialState: RefillAlertsList = {
  isLoading: false,
  error: false,
  message: null,
  RefillAlertsListData: [],
  Items: [],
  Pagination: [],
};

const RefillAlertsListSlice = createSlice({
  name: "RefillAlertsList",
  initialState,
  reducers: {
    loadingRefillAlertsList: (
      state: RefillAlertsList,
      action: PayloadAction<{}>
    ) => {
      state.isLoading = true;
    },
    setRefillAlertsList: (
      state: any,
      action: PayloadAction<RefillAlertsList>
    ) => {
      return action.payload;
    },
    clearData: (state: RefillAlertsList, action: PayloadAction) => {
      state.error = false;
    },
  },
});

export const { loadingRefillAlertsList, setRefillAlertsList, clearData } =
  RefillAlertsListSlice.actions;
export default RefillAlertsListSlice.reducer;
